import { ISupplierStatement } from '$models'
import { supplierStatementService } from '$services'
import { enqueueLoadedSnackbar, exceptionMessageHandler } from '$utils'
import { SharedSlice } from 'src/components/slice'
import { StateCreator } from 'zustand'

interface AddSupplierStatementState {}

export interface AddSupplierStatementSlice extends AddSupplierStatementState {
  resetAddStatementSlice: () => void

  addSupplierStatement: (
    supplierStatement: ISupplierStatement,
    successMessage?: string,
    errorMessage?: string
  ) => Promise<ISupplierStatement | null>
}

const initialState: AddSupplierStatementState = {}

const createAddSupplierStatementSlice: StateCreator<
  AddSupplierStatementSlice & SharedSlice,
  [],
  [],
  AddSupplierStatementSlice
> = (set) => ({
  ...initialState,

  resetAddStatementSlice: () => set(initialState),

  addSupplierStatement: async (
    supplierStatement: ISupplierStatement,
    successMessage?: string,
    errorMessage?: string
  ): Promise<ISupplierStatement | null> => {
    try {
      set(() => ({ isLoading: true }))

      const newSupplierStatement: ISupplierStatement =
        await supplierStatementService.createSupplierStatement(
          supplierStatement
        )

      enqueueLoadedSnackbar(successMessage, 'success')
      return newSupplierStatement
    } catch (error) {
      exceptionMessageHandler(
        error,
        errorMessage ?? 'Failed to retrieve supplier statement'
      )
      return null
    } finally {
      set(() => ({ isLoading: false }))
    }
  },
})

export default createAddSupplierStatementSlice
